<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="fas fa-bars text-white text-center" />
        </button>
        <button
          id="minimizeSidebar"
          class="btn btn-icon btn-round"
          @click="goBack"
          style="margin-left: 1em"
        >
          <i class="el-icon-back" />
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar" />
      </div>
    </div>
    <template slot="navbar-menu">
      <!-- <form>
        <div class="input-group no-border">
          <input
            type="text"
            value=""
            class="form-control"
            placeholder="Search..."
          >
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="nc-icon nc-zoom-split" />
            </div>
          </div>
        </div>
      </form> -->
      <ul class="navbar-nav">
        <a :href="smartsheet" target="_blank">
          <div class="report-issue">
            <i class="fas fa-bug" />
            <span class="issue-text">Report an issue</span>
          </div>
        </a>
        <div v-if="!isImpersonating" class="name-top-left">
          {{ name }}
        </div>
        <div v-else class="name-top-left">
          <drop-down
            icon="nc-icon nc-settings-gear-65"
            tag="li"
            position="right"
            direction="none"
            class="nav-item btn-rotate dropdown"
          >
            <a
              slot="title"
              slot-scope="{isOpen}"
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              :aria-expanded="isOpen"
            >
              {{ name }}
            </a>
            <a class="dropdown-item" @click="revertToAdmin()">Revert to Admin</a>
          </drop-down>
        </div>
        <drop-down
          v-if="hasDelegations"
          icon="nc-icon nc-settings-gear-65"
          tag="li"
          position="right"
          direction="none"
          class="nav-item btn-rotate dropdown"
        >
          <a
            slot="title"
            slot-scope="{isOpen}"
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            :aria-expanded="isOpen"
          >
            {{ currentDelegation ? currentDelegation.name : "Select Role" }}
          </a>
          <a
            v-for="delegation in delegations"
            :key="delegation.id"
            class="dropdown-item"
            :class="{ 'selected-delegation': delegation.current }"
            @click="selectDelegation(delegation)"
          >
            {{ delegation.name }}
          </a>
        </drop-down>
        <drop-down
          icon="nc-icon nc-settings-gear-65"
          tag="li"
          position="right"
          direction="none"
          class="nav-item btn-rotate dropdown"
        >
          <a
            slot="title"
            slot-scope="{isOpen}"
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            :aria-expanded="isOpen"
          >
            <i class="nc-icon nc-settings-gear-65" />
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <a class="dropdown-item" @click="logout">Logout</a>
        </drop-down>
      </ul>
    </template>
  </navbar>
</template>
<script>
import { Navbar, NavbarToggleButton } from 'src/components/UIComponents';
import Mgr from 'src/services/SecurityService';
import { mapState } from 'vuex';
import apiService from '../../repositories/apiService';

export default {
    components: {
        Navbar,
        NavbarToggleButton
    },
    data() {
        return {
            activeNotifications: false,
            showNavbar: false,
            mgr: new Mgr(),
            name: 'test',
            smartsheet: process.env.VUE_APP_SMARTSHEET,
            isImpersonating: false,
            delegations: []
        };
    },
    computed: {
    // Map the getters from Vuex to your component
        ...mapState({
            hasDelegations: (state) => state.hasDelegations
        }),
        currentDelegation() {
            return this.delegations.find((delegation) => delegation.current === true);
        }
    },
    watch: {
        hasDelegations(newValue) {
            if (newValue === true) {
                this.populateDelegations();
            }
        }
    },
    mounted() {
        // extract and assign profile name
        this.mgr.getProfile()
            .then((profile) => {
                if (profile) {
                    this.name = profile.name;
                } else {
                    this.name = null;
                }
            });
    },
    created() {
        this.setIsImpersonating();
        if (this.hasDelegations) {
            this.populateDelegations();
        }
    },
    methods: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown() {
            this.activeNotifications = false;
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },
        minimizeSidebar() {
            this.$sidebar.toggleMinimize();
        },
        toggleNavbar() {
            this.showNavbar = !this.showNavbar;
        },
        goBack() {
            return this.$router.go(-1);
        },
        goForward() {
            return this.$router.go(1);
        },
        async logout() {
            // signout by removing token
            window.localStorage.clear();
            window.sessionStorage.clear();
            // proceed
            this.$router.push('/logout');
        },
        revertToAdmin() {
            apiService
                .get('/revert-to-admin/')
                .then((response) => {
                    this.$router.go('/main');
                }).catch((error) => {
                    this.$store.commit('setError', error);
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },
        setIsImpersonating() {
            apiService
                .get('/is-impersonating/')
                .then((response) => {
                    if (response.data !== false) {
                        this.isImpersonating = true;
                        this.name = response.data;
                    }
                }).catch((error) => {
                    this.$store.commit('setError', error);
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },
        populateDelegations() {
            apiService
                .get('/my-delegations')
                .then((response) => {
                    this.delegations = response.data;
                }).catch((error) => {
                    this.$store.commit('setError', error);
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },
        // Method to handle selecting a delegation
        selectDelegation(delegation) {
            apiService
                .post('/switch-delegations', {
                    newly_selected_delegation_id: delegation.id,
                    is_new_selection_the_root_user: delegation.isRoot
                })
                .then((response) => {
                    // refresh the page
                    this.$router.go();
                }).catch((error) => {
                    this.$store.commit('setError', error);
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },
    }
};

</script>
<style>

.name-top-left {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #66615b;
}
.report-issue {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #66615b;
  padding: 8px 11.2px;
}
.issue-text {
  padding-left: 5px;
  font-size: .7em;
  margin-top: 8px;
}
.bug-icon {
  margin-top: 3px;
}
/* Highlight the selected/current delegation */
.selected-delegation {
  font-weight: bold;
  background-color: #f0f0f0; /* Custom styling for the selected delegation */
}
</style>
